import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const straightForwardBadgeDefinition: BoggleBadgeDefinition = {
  category: 'path',
  description: 'Play a word using all tiles in a single row from left to right',
  iconId: 'straightForward',
  id: 'straightForward',
  level: 'uncommon',
  lockedReveal: 'reveal',
  name: 'Straight Forward',
  points: getBoggleBadgePointsForLevel('uncommon'),
}
